import { Breadcrumb } from "app/components";
import { Box, styled, Divider, Grid } from "@mui/material";
import PropTypes from "prop-types";

const Container = styled("div")(({ theme, compactMargins }) => ({
  margin: compactMargins ? "8px 12px" : "30px",
  [theme.breakpoints.down("sm")]: {
    margin: compactMargins ? "8px 10px" : "16px",
  },
  "& .breadcrumb": {
    marginBottom: compactMargins ? "10px" : "30px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: compactMargins ? "8px" : "16px",
    },
  },
}));

/** Standard list pages: disableInnerScroll=true (page owns vertical scroll). */
const C1ListPanel = ({
  routeSegments,
  showSelection,
  children,
  disableInnerScroll = true,
  compactMargins = false,
}) => {
  const selectComponent = showSelection || null;

  return (
    <Container compactMargins={compactMargins}>
      {routeSegments && (
        <div className="mb-sm-30">
          <Box className="breadcrumb">
            <Breadcrumb routeSegments={routeSegments} />
          </Box>
        </div>
      )}
      <div
        className={disableInnerScroll ? undefined : "overflow-auto"}
        style={disableInnerScroll ? { width: "100%", maxWidth: "100%" } : undefined}
      >
        <div
          className={disableInnerScroll ? undefined : "min-w-750"}
          style={disableInnerScroll ? { width: "100%", maxWidth: "100%" } : undefined}
        >
          <Grid container spacing={0}>
            {selectComponent && (
              <Grid item xs={12}>
                <Grid container item direction="row" justify="flex-end" alignItems="flex-end">
                  <Grid item xs={6}>
                    {selectComponent}
                  </Grid>
                </Grid>
              </Grid>
            )}
            {selectComponent && (
              <Grid item xs={12}>
                <Divider />
              </Grid>
            )}
            <Grid item xs={12}>
              {children}
            </Grid>
          </Grid>
        </div>
      </div>
    </Container>
  );
};

C1ListPanel.propTypes = {
  showSelection: PropTypes.element,
  routeSegments: PropTypes.array,
  children: PropTypes.element,
  disableInnerScroll: PropTypes.bool,
  compactMargins: PropTypes.bool,
};

export default C1ListPanel;
